<script>

import { formatAmount } from '../lib/formatters';

export default {
  props: {
    amountFrom: {
      type: Object,
      required: false,
      default: null
    },
    amountTo: {
      type: Object,
      required: true
    }
  },

  methods: {
    formattedAmount(amount) {
      return formatAmount(amount.cents, true);
    }
  }
};
</script>

<template>
  <span>
    <span
      v-if="amountFrom"
      class="me-2"
    >
      <del>{{ formattedAmount(amountFrom) }}</del>
    </span>

    <strong>{{ formattedAmount(amountTo) }}</strong>
  </span>
</template>
